AOS.init();

//

(function () {
    var banner = document.getElementById('top-banner');
    var closeBtn = document.getElementById('top-banner-close');
    if (!banner || !closeBtn) return;

    if (document.cookie.indexOf('top_banner_closed=1') !== -1) {
        banner.style.display = 'none';
    }

    closeBtn.addEventListener('click', function () {
        banner.style.display = 'none';
        var expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = 'top_banner_closed=1; expires=' + expires + '; path=/';
    });
})();

//


const sliderStories = document.querySelector('.block__stories');
if (sliderStories) {
    let isDown = false;
    let startX;
    let scrollLeft;

    sliderStories.addEventListener('mousedown', (e) => {
        isDown = true;
        sliderStories.classList.add('active');
        startX = e.pageX - sliderStories.offsetLeft;
        scrollLeft = sliderStories.scrollLeft;
    });

    sliderStories.addEventListener('mouseleave', () => {
        isDown = false;
        sliderStories.classList.remove('active');
    });

    sliderStories.addEventListener('mouseup', () => {
        isDown = false;
        sliderStories.classList.remove('active');
    });

    sliderStories.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - sliderStories.offsetLeft;
        const walk = (x - startX);
        sliderStories.scrollLeft = scrollLeft - walk;
    });
}


//

$(document).ready(function () {
    $('.menu > li > a').on('click', function () {
        if ($(window).width() <= 1024) {
            $('.menu > li > a + ul').toggleClass('active');
        }
    });
});

// //

(function () {
    const element = document.getElementById("langDropdown");
    const desktopParent = document.querySelector(".block__lang");
    const mobileParent = document.getElementById("menu");

    if (!element || !desktopParent || !mobileParent) return;

    function moveElement() {
        if (window.innerWidth <= 1024) {
            if (!mobileParent.contains(element)) {
                mobileParent.prepend(element);
            }
        } else {
            if (!desktopParent.contains(element)) {
                desktopParent.appendChild(element);
            }
        }
    }

    window.addEventListener("load", moveElement);
    window.addEventListener("resize", moveElement);

    const buttonLang = document.getElementById("langButton");
    const optionsLang = element.querySelectorAll(".dropdown-content div");

    if (buttonLang) {
        buttonLang.addEventListener("click", () => {
            element.classList.toggle("show");
        });
    }

    optionsLang.forEach(optionLang => {
        optionLang.addEventListener("click", () => {
            const selected = optionLang.getAttribute("data-lang");
            if (buttonLang) buttonLang.textContent = selected;
            element.classList.remove("show");
        });
    });

    window.addEventListener("click", e => {
        if (!element.contains(e.target)) {
            element.classList.remove("show");
        }
    });
})();

// //


document.querySelectorAll(".dropdown_clickSelecting").forEach(dropdown => {
    const selected = dropdown.querySelector(".selectedSelecting span");
    const options = dropdown.querySelectorAll(".drop-contentSelecting li span");

    options.forEach(option => {
        option.addEventListener("click", () => {
            selected.textContent = option.textContent;

            dropdown.classList.remove("active");

            options.forEach(o => o.classList.remove("selectedOption"));

            option.classList.add("selectedOption");
        });
    });
});

$(".parent input").on('click', function () {
    var _parent = $(this);
    var nextli = $(this).parent().next().children().children();

    if (_parent.prop('checked')) {
        console.log('parent checked');
        nextli.each(function () {
            $(this).children().prop('checked', true);
        });
    } else {
        console.log('parent un checked');
        nextli.each(function () {
            $(this).children().prop('checked', false);
        });
    }
});

$(".child input").on('click', function () {

    var ths = $(this);
    var parentinput = ths.closest('div').prev().children();
    var sibblingsli = ths.closest('ul').find('li');

    if (ths.prop('checked')) {
        parentinput.prop('checked', true);
    } else {
        var status = true;
        sibblingsli.each(function () {
            if ($(this).children().prop('checked')) status = false;
        });
        if (status) parentinput.prop('checked', false);
    }
});

//

$(".dropdown_click").each(function () {
    $(this).find(".selected").on('click', function (e) {
        e.stopPropagation();

        const $dropdown = $(this).parent(".dropdown_click");

        if ($dropdown.hasClass("active")) {
            $dropdown.removeClass("active");
        } else {
            $(".dropdown_click").removeClass("active");
            $dropdown.addClass("active");
        }
    });
});


$(document).on("click", function (e) {
    if (!$(e.target).closest(".dropdown_click").length) {
        $(".dropdown_click").removeClass("active");
    }
});


//

(function ($) {
    function applyPricing(type) {
        var price = $('.table__price').not('.table__price--old');
        var oldPrice = $('.table__price--old');
        var discountLabel = $('.table__discount-label');
        var orderLink = $('.order');
        var tooltip = $('.tooltip-content');

        var month = $("#month");
        var six_month = $("#six_month");
        var year = $("#year");

        month.removeClass('active');
        six_month.removeClass('active');
        year.removeClass('active');

        if (type === 'month') month.addClass('active');
        if (type === 'six_month') six_month.addClass('active');
        if (type === 'year') year.addClass('active');

        price.each(function () {
            $(this).text($(this).data(type.replace('_', '-') + '-price'));
        });

        oldPrice.each(function () {
            $(this).text($(this).data(type.replace('_', '-') + '-price'));
        });

        discountLabel.each(function () {
            $(this).text('-' + $(this).data(type.replace('_', '-') + '-percent') + '%');
        });

        orderLink.each(function () {
            $(this).attr('href', $(this).data(type.replace('_', '-') + '-url'));
        })

        tooltip.each(function () {
            $(this).text($(this).data(type.replace('_', '-') + '-text'));
        });
    }

    function initPricingSwitcher() {

        $('#month, #six_month, #year').off('click.pricing');

        $('#month').on('click.pricing', function () {
            applyPricing('month');
        });

        $('#six_month').on('click.pricing', function () {
            applyPricing('six_month');
        });

        $('#year').on('click.pricing', function () {
            applyPricing('year');
        });
    }

    $(document).ready(function () {
        initPricingSwitcher();
    });

    window.initPricingSwitcher = initPricingSwitcher;
    window.applyPricing = applyPricing;

})(jQuery);

//

$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    const target = $.attr(this, 'href');

    if (target.length > 1 && $(target).length) {
        $('html, body').animate({
            scrollTop: $(target).offset().top
        }, 500);
    }
});

//

const sections = document.querySelectorAll("section[id]");

window.addEventListener("scroll", navHighlighter);

function navHighlighter() {

    let scrollY = window.pageYOffset;

    sections.forEach(current => {
        const sectionHeight = current.offsetHeight;

        const sectionTop = (current.getBoundingClientRect().top + window.pageYOffset) - 50;

        // sectionId = current.getAttribute("id");

        const sectionId = current.getAttribute("id");

        if (
            scrollY > sectionTop &&
            scrollY <= sectionTop + sectionHeight
        ) {
            if (document.querySelector(".navigation a[href*=" + sectionId + "]")) {
                document.querySelector(".navigation a[href*=" + sectionId + "]").classList.add("active");
            }
        } else {
            if (document.querySelector(".navigation a[href*=" + sectionId + "]")) {
                document.querySelector(".navigation a[href*=" + sectionId + "]").classList.remove("active");
            }
        }
    });
}

//

$(".popup_open__ask").on("click", function () {
    $(".popup_box__ask").addClass("opened");
});
$(".popup_close__ask, .popup_overlay__ask").click(function () {
    $(".popup_box__ask").removeClass("opened");
});

$(".popup_open__custom_server").on("click", function () {
    $(".popup_box__ask").addClass("opened");
});
$(".popup_close__custom_server").click(function () {
    $(".popup_box__ask").removeClass("opened");
});

/*document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('form');
    const button = form.querySelector('.send');

    form.addEventListener('submit', () => {
        button.classList.add('loading');

    });
});*/

//

jQuery(function () {
    initOpenMenu();
    initRating();
    initContentShow();
    initShowAllReviews();
    initShowOriginalReview();
    initFaq();
    initShowHideStories();
    initSubMenuOpenMobile();
    initOpenPost();
});


//

function initOpenPost() {
    $(".open__post").on("click", function (e) {
        e.stopPropagation();
        $(this).next(".inner__box").toggleClass("active");
    });
    $(".inner__box").on("click", function (e) {
        e.stopPropagation();
    });
    $(document).on("click", function () {
        $(".inner__box").removeClass("active");
    });
}

function initSubMenuOpenMobile() {
    $(".arrow__menu").on("click", function () {
        $(this).parent(".inner").toggleClass("active");
    });
}


//

function initShowHideStories() {

    $(".show_hide__stories").on("click", function () {
        // $(this).toggleClass("active");
        $(this).parent(".row__stories").toggleClass("active");
    });

}

$('.link__interactive__israel').on("mouseover", function () {
    $(this).css({opacity: 0.5});
    $('.interactive__israel').css({fill: "#00A3FF"});
});
$('.link__interactive__israel').on("mouseout", function () {
    $(this).css({opacity: 1});
    $('.interactive__israel').css({fill: "#627790"});
});


$('.link__interactive__china').on("mouseover", function () {
    $(this).css({opacity: 0.5});
    $('.interactive__china').css({fill: "#00A3FF"});
});
$('.link__interactive__china').on("mouseout", function () {
    $(this).css({opacity: 1});
    $('.interactive__china').css({fill: "#627790"});
});


$('.link__interactive__cyprus').on("mouseover", function () {
    $(this).css({opacity: 0.5});
    $('.interactive__cyprus').css({fill: "#00A3FF"});
});
$('.link__interactive__cyprus').on("mouseout", function () {
    $(this).css({opacity: 1});
    $('.interactive__cyprus').css({fill: "#627790"});
});


$('.link__interactive__singapore').on("mouseover", function () {
    $(this).css({opacity: 0.5});
    $('.interactive__singapore').css({fill: "#00A3FF"});
});
$('.link__interactive__singapore').on("mouseout", function () {
    $(this).css({opacity: 1});
    $('.interactive__singapore').css({fill: "#627790"});
});


$('.link__interactive__poland').on("mouseover", function () {
    $(this).css({opacity: 0.5});
    $('.interactive__poland').css({fill: "#00A3FF"});
});
$('.link__interactive__poland').on("mouseout", function () {
    $(this).css({opacity: 1});
    $('.interactive__poland').css({fill: "#627790"});
});


$('.link__interactive__estonia').on("mouseover", function () {
    $(this).css({opacity: 0.5});
    $('.interactive__estonia').css({fill: "#00A3FF"});
});
$('.link__interactive__estonia').on("mouseout", function () {
    $(this).css({opacity: 1});
    $('.interactive__estonia').css({fill: "#627790"});
});


$('.link__interactive__netherlands').on("mouseover", function () {
    $(this).css({opacity: 0.5});
    $('.interactive__netherlands').css({fill: "#00A3FF"});
});
$('.link__interactive__netherlands').on("mouseout", function () {
    $(this).css({opacity: 1});
    $('.interactive__netherlands').css({fill: "#627790"});
});


$('.link__interactive__sweden').on("mouseover", function () {
    $(this).css({opacity: 0.5});
    $('.interactive__sweden').css({fill: "#00A3FF"});
});
$('.link__interactive__sweden').on("mouseout", function () {
    $(this).css({opacity: 1});
    $('.interactive__sweden').css({fill: "#627790"});
});

//

function initOpenMenu() {
    $(".link__open_menu").click(function () {
        $(this).toggleClass('open');
        $(this).parent(".nav__menu").toggleClass('open');
        $(this).parents("body").toggleClass('open__menu');
    });
}

function initFaq() {
    $(".faq li .opener").click(function () {
        if ($(this).parents("li").hasClass("active")) {
            $(".faq li").removeClass("active");
            $(this).parents("li").removeClass("active");
        } else {
            $(".faq li").removeClass("active");
            $(this).parents("li").addClass("active");
        }
    });
}

function initShowAllReviews() {
    $(".link__reviews_all").on("click", function () {
        $(this).parent(".reviews__box").toggleClass("active");
    });
}

function initContentShow() {
    $(".link__show_hide").on("click", function () {
        $(this).parent(".content__show_hide").addClass("opened");
    });
}

function initShowOriginalReview() {
    $(document).on("click", ".link__show_original", function (e) {
        e.preventDefault();

        var $link = $(this);
        var $li = $link.closest("li");
        var $title = $li.find(".review__title");
        var $comment = $li.find(".review__comment");
        var showingOriginal = $link.hasClass("active");

        if (showingOriginal) {
            $title.text($title.data("translated-title"));
            $comment.text($comment.data("translated-comment"));
            $link.removeClass("active");
            $link.find("span").text($link.data("label-translated"));
        } else {
            $title.text($title.data("original-title"));
            $comment.text($comment.data("original-comment"));
            $link.addClass("active");
            $link.find("span").text($link.data("label-original"));
        }
    });
}

function initRating() {
    // rating
    !(function (a) {
        "use strict";

        function b(a) {
            return "[data-value" + (a ? "=" + a : "") + "]";
        }

        function c(a, b, c) {
            var d = c.activeIcon,
                e = c.inactiveIcon;
            a.removeClass(b ? e : d).addClass(b ? d : e);
        }

        function d(b, c) {
            var d = a.extend({}, i, b.data(), c);
            return (
                (d.inline = "" === d.inline || d.inline),
                    (d.readonly = "" === d.readonly || d.readonly),
                    d.clearable === !1
                        ? (d.clearableLabel = "")
                        : (d.clearableLabel = d.clearable),
                    (d.clearable = "" === d.clearable || d.clearable),
                    d
            );
        }

        function e(b, c) {
            if (c.inline) var d = a('<span class="rating-input"></span>');
            else var d = a('<div class="rating-input"></div>');
            c.copyClasses && (d.addClass(b.attr("class")), d.removeClass("rating"));
            for (var e = c.min; e <= c.max; e++)
                d.append('<i class="' + c.iconLib + '" data-value="' + e + '"></i>');
            return (
                c.clearable &&
                !c.readonly &&
                d
                    .append("&nbsp;")
                    .append(
                        '<a class="' +
                        f +
                        '"><i class="' +
                        c.iconLib +
                        " " +
                        c.clearableIcon +
                        '"/>' +
                        c.clearableLabel +
                        "</a>"
                    ),
                    d
            );
        }

        var f = "rating-clear",
            g = "." + f,
            h = "hidden",
            i = {
                min: 1,
                max: 5,
                "empty-value": 0,
                iconLib: "glyphicon",
                activeIcon: "glyphicon-star",
                inactiveIcon: "glyphicon-star-empty",
                clearable: !1,
                clearableIcon: "glyphicon-remove",
                clearableRemain: !1,
                inline: !1,
                readonly: !1,
                copyClasses: !0,
            },
            j = function (a, b) {
                var c = (this.$input = a);
                this.options = d(c, b);
                var f = (this.$el = e(c, this.options));
                c.addClass(h).before(f),
                    c.attr("type", "hidden"),
                    this.highlight(c.val());
            };
        (j.VERSION = "0.4.0"),
            (j.DEFAULTS = i),
            (j.prototype = {
                clear: function () {
                    this.setValue(this.options["empty-value"]);
                },
                setValue: function (a) {
                    this.highlight(a), this.updateInput(a);
                },
                highlight: function (a, d) {
                    var e = this.options,
                        f = this.$el;
                    if (a >= this.options.min && a <= this.options.max) {
                        var i = f.find(b(a));
                        c(i.prevAll("i").addBack(), !0, e), c(i.nextAll("i"), !1, e);
                    } else c(f.find(b()), !1, e);
                    d ||
                    (this.options.clearableRemain
                        ? f.find(g).removeClass(h)
                        : a && a != this.options["empty-value"]
                            ? f.find(g).removeClass(h)
                            : f.find(g).addClass(h));
                },
                updateInput: function (a) {
                    var b = this.$input;
                    b.val() != a && b.val(a).change();
                },
            });
        var k = (a.fn.rating = function (c) {
            return this.filter("input[type=number]").each(function () {
                var d = a(this),
                    e = ("object" == typeof c && c) || {},
                    f = new j(d, e);
                f.options.readonly ||
                f.$el
                    .on("mouseenter", b(), function () {
                        f.highlight(a(this).data("value"), !0);
                    })
                    .on("mouseleave", b(), function () {
                        f.highlight(d.val(), !0);
                    })
                    .on("click", b(), function () {
                        f.setValue(a(this).data("value"));
                    })
                    .on("click", g, function () {
                        f.clear();
                    });
            });
        });
        (k.Constructor = j),
            a(function () {
                a("input.rating[type=number]").each(function () {
                    a(this).rating();
                });
            });
    })(jQuery);
}
document.addEventListener('DOMContentLoaded', function() {
    const tooltips = document.querySelectorAll('.tooltip-wrapper');

    tooltips.forEach(tooltip => {
        const icon = tooltip.querySelector('.tooltip-icon');
        const content = tooltip.querySelector('.tooltip-content');

        icon.addEventListener('click', function(e) {
            e.stopPropagation();

            tooltips.forEach(t => {
                if (t !== tooltip) {
                    t.classList.remove('active');
                }
            });

            tooltip.classList.toggle('active');
        });
    });

    document.addEventListener('click', function(e) {
        if (!e.target.closest('.tooltip-wrapper')) {
            tooltips.forEach(tooltip => {
                tooltip.classList.remove('active');
            });
        }
    });
});

(function () {
    const section     = document.querySelector('.section__plans');
    const filtersRow  = document.querySelector('.row__drop');
    const tableWrap   = document.getElementById('product_table');

    if (!section || !filtersRow || !tableWrap) return;

    function filtersHeight() {
        return filtersRow.offsetHeight;
    }

    function isSectionActive() {
        const rect = section.getBoundingClientRect();
        return rect.top <= 0 && rect.bottom > window.innerHeight;
    }

    function tableAtBottom() {
        return tableWrap.scrollTop + tableWrap.clientHeight >= tableWrap.scrollHeight - 2;
    }

    function tableAtTop() {
        return tableWrap.scrollTop <= 0;
    }

    window.addEventListener('wheel', function (e) {
        if (!isSectionActive()) return;

        const scrollingDown = e.deltaY > 0;
        const scrollingUp   = e.deltaY < 0;

        if (scrollingDown && !tableAtBottom()) {
            e.preventDefault();
            tableWrap.scrollTop += e.deltaY;
            return;
        }

        if (scrollingUp && !tableAtTop()) {
            e.preventDefault();
            tableWrap.scrollTop += e.deltaY;
            return;
        }

    }, { passive: false });

    let touchStartY = 0;

    window.addEventListener('touchstart', function (e) {
        touchStartY = e.touches[0].clientY;
    }, { passive: true });

    window.addEventListener('touchmove', function (e) {
        if (!isSectionActive()) return;

        const deltaY      = touchStartY - e.touches[0].clientY;
        const scrollingDown = deltaY > 0;
        const scrollingUp   = deltaY < 0;

        if (scrollingDown && !tableAtBottom()) {
            e.preventDefault();
            tableWrap.scrollTop += deltaY;
            touchStartY = e.touches[0].clientY;
            return;
        }

        if (scrollingUp && !tableAtTop()) {
            e.preventDefault();
            tableWrap.scrollTop += deltaY;
            touchStartY = e.touches[0].clientY;
            return;
        }

    }, { passive: false });

})();

const btn = document.getElementById('show-more-btn');
if(btn != null) {
    btn.addEventListener('click', () => {
        const rows = document.querySelectorAll('.hide_product');

        rows.forEach(row => {
            row.style.display = 'table-row';
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    row.style.opacity = '1';
                });
            });
        });

        btn.style.display = 'none';
    });
}
//------add GA params to links start-------------

var FROM = 'blueservers';
var HOST = 'my.bluevps.com';
var DEV_HOSR = 'devbluevps.com';
var LINK_ATTRS = ['href', 'data-month-url', 'data-six-month-url', 'data-year-url'];

function appendParams(url, params) {
    var parsed;
    try {
        parsed = new URL(url, window.location.href);
    } catch (e) {
        return url;
    }
    if (parsed.hostname !== HOST && parsed.hostname.indexOf(DEV_HOSR) === -1) return url;

    Object.keys(params).forEach(function (key) {
        if (params[key]) parsed.searchParams.set(key, params[key]);
    });

    return parsed.toString();
}

function updateLinks(params) {
    var selector = LINK_ATTRS.map(function (attr) {
        return '[' + attr + ']';
    }).join(',');

    document.querySelectorAll(selector).forEach(function (el) {
        LINK_ATTRS.forEach(function (attr) {
            var value = el.getAttribute(attr);
            if (!value) return;
            el.setAttribute(attr, appendParams(value, params));
        });
    });
}

function trackLinks(measurementId) {
    var params = {from: FROM};
    var pending = 2;

    function maybeApply() {
        pending--;
        if (pending === 0) updateLinks(params);
    }

    gtag('get', measurementId, 'client_id', function (clientId) {
        params.ga_client_id = clientId;
        maybeApply();
    });

    gtag('get', measurementId, 'session_id', function (sessionId) {
        params.ga_session_id = sessionId;
        maybeApply();
    });
}

window.trackLinks = trackLinks;
//------add GA params to links end---------------

//------company history timeline---------------
// The line runs from the first year's dot to the last one (dots sit at the vertical center of each item)
function updateHistoryLine() {
	document.querySelectorAll('.history__items').forEach(function (list) {
		var items = list.querySelectorAll(':scope > .item');
		if (!items.length) return;

		var first = items[0];
		var last = items[items.length - 1];

		list.style.setProperty('--line-top', (first.offsetTop + first.offsetHeight / 2) + 'px');
		list.style.setProperty('--line-bottom', (list.offsetHeight - last.offsetTop - last.offsetHeight / 2) + 'px');
	});
}

updateHistoryLine();
window.addEventListener('load', updateHistoryLine);
window.addEventListener('resize', updateHistoryLine);
//------company history timeline end---------------

//------compare servers start-------------

function initCompareWidget(i18n) {
    var STORAGE_KEY = 'compare_servers';
    var MAX_ITEMS = 4;
    var I18N = i18n;

    function readProductIds() {
        var raw = getCookie(STORAGE_KEY);
        if (!raw) return [];

        return decodeURIComponent(raw)
            .split(',')
            .map(function (id) { return parseInt(id, 10); })
            .filter(function (id) { return !isNaN(id); });
    }

    function writeProductIds(ids) {
        var expires = new Date();
        expires.setDate(expires.getDate() + 30);
        document.cookie = STORAGE_KEY + '=' + encodeURIComponent(ids.join(',')) + '; expires=' + expires.toUTCString() + '; path=/';
    }

    function showToast(message) {
        var toast = document.getElementById('compare-toast');
        if (!toast) return;
        toast.textContent = message;
        toast.style.display = 'block';
        clearTimeout(toast._hideTimeout);
        toast._hideTimeout = setTimeout(function () {
            toast.style.display = 'none';
        }, 3000);
    }

    function currentLangPrefix() {
        var parts = window.location.pathname.split('/').filter(Boolean);
        if (parts.length > 0 && parts[0].length === 2) {
            return '/' + parts[0];
        }
        return '';
    }

    function renderBar() {
        var ids = readProductIds();
        var bar = document.getElementById('compare-bar');
        var countLabel = document.getElementById('compare-bar-count');
        var goBtn = document.getElementById('btn-compare-go');

        if (!bar) return;

        bar.style.display = ids.length > 0 ? 'block' : 'none';
        if (countLabel) {
            countLabel.textContent = I18N.selected + ': ' + ids.length;
        }
        if (goBtn) {
            goBtn.textContent = I18N.compare + ' (' + ids.length + ')';
            goBtn.disabled = ids.length < 2;
        }
    }

    function syncCheckboxes() {
        var ids = readProductIds().map(String);

        document.querySelectorAll('.js-compare-checkbox').forEach(function (checkbox) {
            checkbox.checked = ids.indexOf(String(checkbox.dataset.compareId)) !== -1;
        });
    }

    function addItem(checkbox) {
        var ids = readProductIds();
        var id = parseInt(checkbox.dataset.compareId, 10);

        if (ids.indexOf(id) !== -1) {
            return true;
        }

        if (ids.length >= MAX_ITEMS) {
            checkbox.checked = false;
            showToast(I18N.maxReached);
            return false;
        }

        ids.push(id);
        writeProductIds(ids);
        return true;
    }

    function removeItem(id) {
        var ids = readProductIds().filter(function (itemId) { return itemId !== parseInt(id, 10); });
        writeProductIds(ids);
        syncCheckboxes();
        renderBar();
    }

    function overwrite(items) {
        var ids = (items || []).slice(0, MAX_ITEMS).map(function (item) { return item.id; });
        writeProductIds(ids);
        syncCheckboxes();
        renderBar();
    }

    function clearAll() {
        writeProductIds([]);
        syncCheckboxes();
        renderBar();
    }

    document.addEventListener('change', function (e) {
        if (!e.target.matches('.js-compare-checkbox')) return;

        if (e.target.checked) {
            addItem(e.target);
        } else {
            removeItem(e.target.dataset.compareId);
        }

        syncCheckboxes();
        renderBar();
    });

    syncCheckboxes();
    renderBar();

    var clearBtn = document.getElementById('btn-compare-clear');
    if (clearBtn) {
        clearBtn.addEventListener('click', clearAll);
    }

    var goBtn = document.getElementById('btn-compare-go');
    if (goBtn) {
        goBtn.addEventListener('click', function () {
            var ids = readProductIds();
            if (ids.length < 2) return;
            window.location.href = currentLangPrefix() + '/compare-servers?ids=' + ids.join(',');
        });
    }

    window.CompareWidget = {
        syncCheckboxes: syncCheckboxes,
        overwrite: overwrite
    };
}

if (document.getElementById('compare-bar')) {
    initCompareWidget(window.compareBarI18n || {});
}
//------compare servers end---------------

